import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const HandsTyping = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="85" viewBox="0 0 148 85" width="148" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path d="M108.14 55.84v-5.15c0-.12.1-.22.22-.22s.22.1.22.22v5.15c0 .12-.1.22-.22.22a.2.2 0 0 1-.22-.22Z" fill={shades.black} />
      <path d="M110.19 53.04c.12 0 .22.1.22.22s-.1.22-.22.22h-3.65a.2.2 0 0 1-.22-.22c0-.12.1-.22.22-.22z" fill={shades.black} />
      <path
        className={strokeStyle}
        d="M100.82 4.39V11a3.87 3.87 0 0 1-3.89 3.87H50.11q-1.19-.02-2.11-.62l-.05-.04a3.8 3.8 0 0 1-1.7-3.21V4.39A3.9 3.9 0 0 1 50.12.5h46.82c1.08 0 2.04.43 2.75 1.14l.05.05a4 4 0 0 1 1.09 2.7z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M104.94 7.82v6.61a3.87 3.87 0 0 1-3.87 3.89H54.25a3.8 3.8 0 0 1-2.89-1.33l-.04-.04-3.32-2.7q.92.6 2.11.62h46.82a3.87 3.87 0 0 0 3.89-3.87V4.39l-.02-.44a4 4 0 0 0-1.07-2.26l3.5 2.91.12.09a3.9 3.9 0 0 1 1.58 3.13z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M110.32 23.87c.2.15.23.43.06.61l-1.01 1.13-1.46 1.63a.4.4 0 0 1-.56.05l-3.89-2.99a.4.4 0 0 0-.57.06l-2.9 3.39a.41.41 0 0 1-.71-.14l-4.65-14.15-.64-1.96a.42.42 0 0 1 .56-.51l14.65 6.33c.27.11.34.46.14.67l-1.23 1.3-1.33 1.4a.4.4 0 0 0 .06.62l.98.72 2.52 1.85z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m93.98 11.5-.17-2.22 15.46 6.19.17 2.2-3.44 3 4.31 1.37.18 2.14-2.12.77z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M110.15 21.66c.2.15.23.43.06.61l-1.01 1.13-1.46 1.63a.4.4 0 0 1-.56.05l-3.89-2.99a.4.4 0 0 0-.57.06l-2.9 3.39a.41.41 0 0 1-.71-.14l-4.65-14.15-.64-1.96a.42.42 0 0 1 .56-.51l14.65 6.33c.27.11.34.46.14.67l-1.23 1.3-1.33 1.4a.4.4 0 0 0 .06.62l.98.72 2.52 1.85z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m.66 81.29 2.58-3.06h76.71l4.72 3.06c.55.35.31 1.2-.34 1.22-11.88.36-73.06-.06-83.17-.13a.66.66 0 0 1-.5-1.09Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M119.14 83.54c13.4 0 24.25-1.96 24.25-4.38s-10.86-4.38-24.25-4.38-24.25 1.96-24.25 4.38 10.86 4.38 24.25 4.38Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M109.17 77.63v2.13a6 6 0 0 1 0-2.13Z" fill={shades.black} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M112.84 79.49h-.01q-1.94.28-3.66.27z" fill={shades.black} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M109.17 77.63v2.13a6 6 0 0 1 0-2.13Z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M138.17 77.63c-6.48 2.86-16.2 3.53-29 2.13q1.71 0 3.66-.27h.01l.07-.01a13.5 13.5 0 0 0 11.02-9.57c1.23-4.21.94-8.28-.57-12.24 8.83 3.78 14.37 15.14 14.8 19.96z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M112.83 79.49q-1.94.28-3.66.27z" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m81.4 74.11-.8 3.6a.7.7 0 0 1-.65.52H3.24a.7.7 0 0 1-.65-.52l-.8-3.6a.67.67 0 0 1 .65-.81h78.31c.42 0 .74.39.65.81Z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M16.35 73.3H4.63l2.25-3.85c2.34.31 4.71.26 7.16-.4l1.84 3.38.47.86z"
        fill={shades.secondary.medium}
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M28.76 73.3H17.04l2.25-3.85c2.34.31 4.71.26 7.16-.4l1.29 2.37z"
        fill={shades.secondary.medium}
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M41.18 73.3H29.46l2.26-3.85q1.86.26 3.75.16 1.68-.1 3.4-.55l1.25 2.3z"
        fill={shades.secondary.medium}
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M53.6 73.3H41.88l2.25-3.85c2.34.31 4.71.26 7.16-.4l1.36 2.49.95 1.75z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M63.71 69.06a13.4 13.4 0 0 1-5.32 4.24H54.3l.92-1.57 1.33-2.27q1.53.21 3.08.18 2.01-.03 4.07-.58z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M66.02 73.3h-7.63a13.3 13.3 0 0 0 5.32-4.24z" fill={shades.black} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M78.43 73.3h-7.35a57 57 0 0 0 6-2.49l1.36 2.49z" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M77.08 70.81a57 57 0 0 1-6 2.49h-4.36l2.25-3.85c2.34.31 4.71.26 7.16-.4l.95 1.75z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M119.8 56.63a36 36 0 0 0-6.48 8.68c-.64-.22-1.45-.1-2.24.46-1.52 1.08-3.16 6.09-1.96 7.35q.36.38.94.5-.53 1.95-.89 4.02a6 6 0 0 0 0 2.13c-3.25-.02-5.91-.8-8.16-2.13a6.7 6.7 0 0 1-.81-3.99c.55-5.71 4.55-14.6 13.67-16.79 2.08-.5 4.06-.54 5.93-.23Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M115.93 78.88q-1.62.4-3.09.61l-3.67.27v-2.13q.36-2.07.89-4.02c.68.12 1.56-.15 2.48-1.23 1.28-1.51 2.14-4.06 1.92-5.61a1.7 1.7 0 0 0-1.14-1.47 36 36 0 0 1 6.48-8.68q1.86.3 3.56 1.05c1.95 5.12 1.86 10.44-.93 16.01a10 10 0 0 1-6.5 5.2Z"
        fill={shades.secondary.medium}
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M112.54 72.39c-.92 1.09-1.8 1.36-2.48 1.23a1.7 1.7 0 0 1-.94-.5c-1.2-1.25.45-6.27 1.96-7.35.78-.56 1.6-.69 2.24-.46.59.21 1.03.72 1.14 1.47.22 1.55-.63 4.1-1.92 5.61Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M136.72 50.71c-1.19-3.95-5.55-6.88-10.99-4.1l-.31.17a17 17 0 0 0-4.94 4.68 16 16 0 0 0-2.57 4.99 9 9 0 0 0-.38 2.41v.23a7.4 7.4 0 0 0 7.07 7.43c.88 0 1.95-.37 3.08-.99 2.94-1.6 6.3-4.87 7.85-7.84.4-.76.87-1.9 1.15-3.13.29-1.26.39-2.64.03-3.83zm-9.94 10.43c-2.09 2.99-5.42 1.6-6.54-1.88-1.11-3.48 1.53-5.89 3.41-4.73 1.46.9 5.21 3.62 3.13 6.61Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M139.39 67.81c-.34-1.61-1.22-3.2-2.43-3.82-1.77-.9-4.06 2.87-3.64 4.6.24.99.99 2.25 2.04 2.98q-1.17.56-2.53.76c-4.6.67-6.04-2.94-5.14-6.81 2.94-1.6 6.3-4.87 7.85-7.84.4-.76.87-1.9 1.15-3.13 1.57.75 4.31 2.6 4.41 6.46.06 2.45-.54 4.85-1.71 6.81z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M126.78 61.14c-2.09 2.99-5.42 1.6-6.54-1.88-1.11-3.48 1.53-5.89 3.41-4.73 1.46.9 5.21 3.62 3.13 6.61Z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M139.39 67.81a9.4 9.4 0 0 1-4.03 3.76 5.4 5.4 0 0 1-2.04-2.98c-.42-1.73 1.87-5.5 3.64-4.6 1.21.62 2.09 2.21 2.43 3.82Z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M125.42 46.77a17 17 0 0 0-4.94 4.68 8.4 8.4 0 0 1-4.28.62 33 33 0 0 1-2.37 4.8c-1.56 2.54-3.56 4.69-6.03 5.38a6.5 6.5 0 0 1-2.82.16c-3.15-.54-5.56-3.48-6.32-7.03.74.55 1.83.97 3.44 1.05 4.52.23 5.77-4.75 4.03-7.3-1.19-1.74-4.27-1.44-6.76-.67a33 33 0 0 1 2.75-5.14c2.74-4.12 6.31-7.15 10.27-8.04 5.56-1.26 10.5 2.7 11.89 6.39.69 1.84 1.01 3.7 1.15 5.11z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M116.2 52.07c1.1-2.71 1.76-5.12 2.03-6.03" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M102.09 56.43a6 6 0 0 1-3.44-1.05l-.14-.75a11 11 0 0 1 .7-5.8l.15-.37c2.49-.77 5.57-1.08 6.76.67 1.74 2.55.49 7.53-4.03 7.3Z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M102.12 43.32a31 31 0 0 0-2.75 5.14l-.15.37a11 11 0 0 0-.7 5.8q-.37-.07-.75-.19c-2.19-.66-4.48-2.31-5.45-4.5a5.6 5.6 0 0 1 .46-5.43c2.37-3.93 5.78-3.31 8.16-1.97q.65.37 1.18.77z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M120.48 51.45a16 16 0 0 0-2.57 4.99q-1.95-.07-4.04.42l-.05.01a32 32 0 0 0 2.37-4.8 8.4 8.4 0 0 0 4.28-.62z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M55.96 46.97c-1.81 2.52-5.21 4.78-8.41 5.98q-.7.25-1.36.45c-2.76.78-7.6.35-8.77-2.57a4.7 4.7 0 0 1 .01-3.12q.5-1.58 1.49-2.96c-.24 1.05-.23 2.12.31 2.93q.46.72 1.54 1.08c3.15 1.02 5.69-2.6 5.35-4.47-.27-1.49-.55-3.23-2.14-4.11a21 21 0 0 1 5.68-2.44q.5-.12.95-.19c7.83-1.19 7.43 6.54 5.35 9.42Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M40.76 48.76a3 3 0 0 1-1.54-1.08c-.55-.81-.56-1.88-.31-2.93q.65-.92 1.47-1.74a19 19 0 0 1 3.6-2.83c1.59.89 1.87 2.63 2.14 4.11.33 1.87-2.21 5.49-5.35 4.47z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M49.65 37.74c-1.69.4-3.73 1.24-5.68 2.44a19 19 0 0 0-3.6 2.83q-.81.83-1.47 1.74a11 11 0 0 0-1.49 2.96 4.5 4.5 0 0 0-.01 3.12c-1.82 2.53-3.52 3.6-7.02 3.33a7 7 0 0 1-2.23-.56 4.3 4.3 0 0 0 3.16-3.8c.34-3.68-1.67-7.83-5.02-7.36-2.05.29-2.98 1.95-3.39 3.2a23 23 0 0 1-.23-5.91q.05-.66.14-1.35c.86-6.73 3.19-13.35 7.85-16.27a10.5 10.5 0 0 1 6.75-1.49c7.61.71 11.18 12.76 12.23 17.14z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M31.33 49.78a4.3 4.3 0 0 1-3.16 3.8c-2.58-1.14-4.52-3.92-5.25-7.97.41-1.25 1.35-2.91 3.39-3.2 3.35-.47 5.35 3.68 5.02 7.36z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M30.68 22.09c-4.66 2.92-6.99 9.54-7.85 16.27q-.1.69-.14 1.35a8 8 0 0 1-3.33.7h-.08c-2.19-.04-4.28-1.24-5.45-3.79.79.12 1.73 0 2.57-.76 1.99-1.8 2.28-5.15 0-5.57a5.2 5.2 0 0 0-3.54.88q.02-.77.13-1.58c.81-5.78 5.17-12.08 11.04-12.2a6.4 6.4 0 0 1 5.87 3.18q.48.78.77 1.52z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M16.4 35.86c-.84.76-1.78.88-2.57.76a12 12 0 0 1-.98-5.24v-.21a5.2 5.2 0 0 1 3.54-.88c2.28.42 2 3.77 0 5.57z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M11.91 49.58a5.3 5.3 0 0 1-2.66-1.79l.43.03c1.75.07 3.69-.73 3.69-2.76 0-3.01-1.98-4.52-4.19-4.65a2.7 2.7 0 0 0-2.37 1.22 19 19 0 0 1-.19-2.35c-.04-2.16.27-4.25.9-5.84 1.35-3.4 3.99-3.88 5.48-3.86q-.11.8-.13 1.58v.21a12 12 0 0 0 .98 5.24c1.17 2.55 3.26 3.75 5.45 3.79h.08q.36 0 .7-.03a43 43 0 0 0 .06 3.91c.17 2.41-2.91 6.83-8.2 5.29z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M13.36 45.06c0 2.03-1.93 2.83-3.69 2.76l-.43-.03C7.93 46.26 7.13 44 6.79 41.63a2.6 2.6 0 0 1 2.37-1.22c2.21.13 4.19 1.64 4.19 4.65z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M9.59 48.16A4 4 0 0 1 9 49.45a2.7 2.7 0 0 1-2.4 1.17c-3.97-.03-5.67-4.53-3.93-8.78 1.15-2.81 2.88-2.86 3.93-2.57q.03 1.17.19 2.35c.34 2.37 1.14 4.63 2.45 6.16z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M47.55 52.94c-7.1 6.66-14.48 6.69-22.11 1.2-7.01 1.27-13.12-.94-16.43-4.69q.4-.58.59-1.29a5.4 5.4 0 0 0 2.32 1.42c5.29 1.54 8.37-2.88 8.2-5.29a47 47 0 0 1-.06-3.91 8 8 0 0 0 2.62-.67q-.26 3.28.23 5.91c.73 4.05 2.67 6.82 5.25 7.97q1.05.47 2.23.56c3.51.28 5.2-.8 7.02-3.33 1.18 2.92 6.01 3.36 8.77 2.57q.67-.2 1.36-.45z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M39.96 33.11c.83 2.36.94 6.31.42 9.89" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M140.59 26.93v2.34" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M136.13 23.16h-2.1" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M140.4 19.37v-2.35" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M144.86 23.13h2.1" strokeWidth={strokeWidth} />
    </svg>
  );
};
